var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 284,
    viewBox: "0 0 248 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.374 42.0562C163.937 45.6096 173.044 50.901 181.209 57.9788C217.744 89.6493 221.685 144.951 190.005 181.486C158.335 218.021 103.033 221.962 66.4981 190.282C46.9734 173.34 36.7597 149.66 36.3228 125.698C88.2655 123.766 130.538 92.3678 154.374 42.0562Z",
    fill: "url(#paint0_linear_1023_10035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7017 66.7755C82.3041 38.406 121.14 29.7068 154.373 42.0566C130.548 92.3779 88.2751 123.767 36.3226 125.699C35.944 104.844 42.9635 83.7758 57.7017 66.7755Z",
    fill: "url(#paint1_linear_1023_10035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0511 132.116C52.6337 132.242 53.1676 132.408 53.624 132.602C58.8474 134.825 61.9445 139.272 66.2261 142.767C70.9738 146.641 73.7214 143.65 78.5953 144.913C84.7216 146.505 85.8187 152.34 93.4305 149.252C99.8093 146.66 102.567 140.417 109.188 138.709C115.606 137.048 120.217 138.99 126.353 139.398C140.257 140.32 141.14 123.495 142.781 113.854C144.344 110.417 138.761 99.0477 140.276 93.7854C142.995 84.3581 162.267 83.6979 169.762 81.3969C182.481 77.4939 171.723 59.7654 166.645 51.6293C165.024 49.3963 163.325 47.2215 161.577 45.0952C168.51 48.406 175.121 52.6973 181.209 57.9692C200.714 74.8822 210.928 98.5331 211.384 122.456C208.549 122.99 205.695 123.844 202.86 125.019C201.403 125.621 187.16 129.136 183.461 133.398C174.714 143.485 165.092 156.107 154.412 166.185C139.703 180.069 122.984 189.117 103.809 180.059C93.3432 175.185 83.6537 168.03 73.1874 162.728C65.0417 158.602 56.4201 155.592 46.585 155.641C45.5947 155.709 45.2743 158.233 44.2743 158.301C43.9248 158.301 43.5947 158.34 43.2548 158.359C41.3713 153.922 35.177 140.864 37.6042 136.252C39.7499 132.184 47.5073 131.107 52.0414 132.107L52.0511 132.116Z",
    fill: "url(#paint2_linear_1023_10035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.557 190.661C145.975 189.564 154.781 200.933 162.849 194.855C170.917 188.787 175.782 179.942 181.112 170.564C187.073 160.068 196.753 152.146 207.899 148.689C204.481 160.428 198.539 171.632 190.005 181.476C158.325 218.011 103.033 221.953 66.4979 190.273C63.9154 188.03 61.4978 185.68 59.2454 183.214C74.7505 182.108 90.945 190.865 104.304 201.021C116.411 209.652 125.693 192.496 137.557 190.651V190.661Z",
    fill: "url(#paint3_linear_1023_10035)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4693 97.232C96.6151 94.9698 105.936 92.6591 106.266 91.9503C110.994 82.0084 109.305 74.115 120.412 68.4742C125.752 65.7654 137.781 65.5324 139.956 58.8623C141.8 53.2215 132.829 46.6776 136.315 40.8037C140.082 34.4541 161.577 45.0951 161.577 45.0951C163.325 47.2116 165.014 49.3864 166.636 51.6195C171.714 59.7556 182.471 77.484 169.752 81.387C158.927 85.5424 144.325 82.3482 139.49 95.2999C135.975 104.708 139.645 116.737 134.14 125.436C127.79 135.466 119.334 129.165 110.072 131.281C101.664 133.204 100.033 145.417 90.3722 145.612C87.1974 145.679 84.4595 144.369 81.4497 143.641C78.4691 142.922 74.9253 143.728 72.2651 142.961C64.9446 140.864 59.8959 132.184 52.7016 129.203C46.9054 126.99 41.8762 140.699 37.1188 135.971C36.0897 134.971 36.2936 122.893 36.3809 120.757C36.8081 109.358 41.4684 96.164 56.5172 99.8437C63.5756 101.572 64.4203 110.174 71.3427 111.475C81.0711 113.3 80.44 104.417 85.576 99.6301C86.3722 98.8922 88.1974 98.0669 90.4596 97.232H90.4693Z",
    fill: "url(#paint4_linear_1023_10035)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2841 158.321C45.2744 158.253 45.5948 155.729 46.5948 155.661C52.2163 155.632 57.4397 156.603 62.4009 158.214C66.2359 159.457 106.033 179.02 107.489 176.253C114.12 163.642 127.402 175.846 136.975 173.244C144.422 171.215 144.412 167.457 147.004 160.768C148.878 155.923 151.364 145.136 156.849 144C161.772 142.981 166.16 148.777 171.519 143.292C174.238 140.515 175.918 133.262 177.801 129.437C180.636 123.689 184.617 117.796 191.695 118.155C193.724 118.252 211.481 127.146 211.384 122.466C211.549 131.282 210.394 140.127 207.899 148.69C196.753 152.146 187.073 160.069 181.112 170.564C175.782 179.943 170.918 188.788 162.849 194.856C154.781 200.934 145.975 189.564 137.558 190.661C125.693 192.506 116.421 209.662 104.305 201.031C90.9451 190.875 74.7507 182.108 59.2455 183.224C52.4007 175.749 47.0608 167.331 43.2646 158.379C43.6045 158.36 43.9346 158.331 44.2841 158.321Z",
    fill: "url(#paint5_linear_1023_10035)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186 186C220.242 151.758 220.242 96.2417 186 62C151.758 27.7583 96.2417 27.7583 62 62C27.7584 96.2416 27.7584 151.758 62 186C96.2417 220.242 151.758 220.242 186 186Z",
    fill: "url(#paint6_linear_1023_10035)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.878 177.127C135.324 175.622 139.392 175.933 142.732 174.204C149.441 170.719 150.208 160.845 156.412 156.534C162.208 152.505 171.937 153.816 174.811 147.369C175.801 145.155 175.578 142.563 176.432 140.291C179.083 133.204 189.782 133.039 194.112 126.825C195.928 124.213 196.355 120.864 197.966 118.126C200.374 114.048 205.034 111.922 209.481 110.271C210.103 110.048 210.666 109.931 211.19 109.931C210.035 102.776 208.025 95.931 205.258 89.4746C205.122 91.9795 204.442 94.3388 202.85 96.3291C197.229 103.417 185.219 100.222 177.869 105.504C173.034 108.98 171.247 115.407 166.956 119.533C159.199 126.98 144.645 125.815 139.509 135.272C137.732 138.543 137.528 142.544 135.528 145.689C129.489 155.185 112.363 150.748 106.042 160.058C104.314 162.612 103.77 165.767 102.537 168.593C100.615 173.02 96.8868 176.622 92.411 178.418C89.8382 179.447 86.9255 179.962 84.9643 181.913C81.0904 185.758 83.1293 192.632 80.4205 197.37C80.0419 198.03 79.5953 198.593 79.1001 199.117C84.1876 202.205 89.6051 204.778 95.2849 206.797C98.217 203.535 100.965 200.04 104.693 197.778C108.877 195.234 114.004 194.418 117.907 191.477C123.285 187.428 125.703 179.845 131.868 177.146L131.878 177.127Z",
    fill: "url(#paint7_linear_1023_10035)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7215 155.146C84.4885 149.369 82.3526 140.884 86.8284 135.631C90.6052 131.204 97.5859 130.932 101.77 126.884C105.615 123.165 106.334 117.01 110.314 113.437C114.635 109.553 121.246 109.99 126.645 107.825C135.451 104.291 140.354 94.1256 149.305 90.9605C156.723 88.3294 166.306 90.7178 171.665 84.941C173.053 83.4458 173.966 81.5331 175.451 80.1351C177.782 77.9506 181.151 77.3486 184.306 76.8437C188.607 76.1544 192.918 75.4651 197.219 74.7757C192.277 67.494 186.277 60.9988 179.432 55.5229C179.053 56.0084 178.655 56.4744 178.218 56.8919C175.277 59.6687 171.306 61.0182 167.432 62.1541C161.053 64.0085 154.558 65.4649 147.995 66.5037C146.315 66.7659 144.519 67.0669 143.305 68.2513C141.528 69.9989 141.752 72.8437 141.198 75.2709C139.558 82.4458 131.159 85.6012 123.878 86.6206C116.586 87.6401 108.392 88.0867 103.431 93.5237C98.1296 99.3296 97.6733 109.796 90.2556 112.417C87.6634 113.33 84.7798 112.971 82.139 113.738C70.5854 117.068 72.6922 136.835 61.8473 142.049C58.9541 143.437 55.5268 143.505 52.7598 145.136C47.7597 148.068 46.8374 154.554 44.4878 159.991C47.0801 165.758 50.284 171.195 54.0025 176.215C55.6433 173.108 57.255 169.904 59.7308 167.574C65.7503 161.923 76.236 162.069 80.7506 155.156L80.7215 155.146Z",
    fill: "url(#paint8_linear_1023_10035)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.404 136.65C207.083 140.029 202.209 143.476 200.772 148.767C199.792 152.388 200.539 156.583 198.374 159.641C194.442 165.224 185.277 162.127 179.316 165.457C172.335 169.36 172.684 180.03 166.801 185.447C161.179 190.622 151.966 189.253 145.587 193.457C139.596 197.409 137.412 205.38 131.703 209.729C130.897 210.341 129.994 210.972 129.12 211.642C171.461 209.438 205.501 177.428 211.384 136.641L211.404 136.65Z",
    fill: "url(#paint9_linear_1023_10035)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8081 126.407C41.381 122.106 49.5074 121.932 54.3133 117.436C61.5464 110.66 58.7114 96.7467 66.9349 91.2127C73.5369 86.766 84.2653 90.2321 89.0712 83.8921C91.6441 80.494 91.178 75.7366 92.615 71.7269C95.916 62.5422 107.547 60.0179 117.295 59.4257C120.13 59.2509 123.111 59.0858 125.518 57.5712C128.383 55.7751 129.878 52.4352 132.315 50.0954C138.499 44.1827 148.461 46.1147 156.849 44.406C157.859 44.2021 158.859 43.9302 159.849 43.639C154.315 41.202 148.48 39.3379 142.431 38.0854C138.422 40.6777 134.354 43.1535 129.373 43.9108C119.994 45.338 109.402 41.8525 100.936 47.5031C97.1976 49.9983 94.6247 54.0081 90.7606 56.3091C84.0711 60.2995 74.168 58.8722 69.6242 65.2025C66.9446 68.921 67.2261 74.125 64.7407 77.9697C60.8085 84.0378 51.6822 84.4844 47.0219 90.0087C42.6723 95.1642 43.4878 103.145 39.6237 108.66C39.0897 109.427 38.4683 110.116 37.8081 110.766C37.0314 115.864 36.6819 121.087 36.8275 126.417L36.8081 126.407Z",
    fill: "url(#paint10_linear_1023_10035)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_10035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.123 270.438C218.259 262.4 200.129 242.039 200.129 242.039L201.487 240.768C201.487 240.768 223.312 265.746 223.207 271.391L221.123 270.438Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.686 260.139C223.123 254.144 205.564 236.956 205.564 236.956L204.205 238.227C204.205 238.227 226.843 260.972 232.498 262.282L231.686 260.139Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.589 237.867L201.619 240.645C201.619 240.645 223.24 262.934 223.107 269.227C222.974 275.521 225.98 264.025 225.98 264.025L231.91 262.252C231.91 262.252 218.459 253.26 214.606 249.405C208.077 242.86 204.583 237.873 204.583 237.873L204.589 237.867Z",
    fill: "#C80923",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.149 241.085C201.149 241.085 220.935 262.101 223.188 271.463L225.095 271.571C225.095 271.571 224.462 265.413 202.273 240.022L201.144 241.079L201.149 241.085Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.652 237.808C204.652 237.808 224.282 258.831 232.401 261.846L232.942 263.447C232.942 263.447 218.315 255.082 203.523 238.865L204.652 237.808Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M209.206 249.113C207.526 248.04 206.009 247.395 204.705 247.013C202.08 243.965 200.249 241.915 200.249 241.915L205.684 236.832C205.684 236.832 216.962 248.372 225.67 255.684C223.949 256.348 222.388 257.84 219.713 257.612C215.764 257.285 214.927 252.759 209.206 249.102L209.206 249.113Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.031 248.945L200.094 249.391C201.469 249.965 203.042 249.751 204.211 248.829C206.168 247.289 209.247 244.721 211.672 241.981C212.676 240.848 212.979 239.253 212.455 237.83L212.057 236.762L199.031 248.945Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M203.193 247.557C205.15 246.017 208.229 243.449 210.653 240.708C211.513 239.732 211.863 238.427 211.61 237.18L212.149 236.676L212.546 237.745C213.071 239.167 212.768 240.762 211.763 241.895C209.333 244.641 206.26 247.204 204.303 248.744C203.134 249.665 201.56 249.879 200.186 249.306L199.123 248.859L199.696 248.323C200.903 248.613 202.195 248.34 203.187 247.562L203.193 247.557Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.413 248.535L197.012 249.038C198.216 249.417 199.535 249.173 200.516 248.384C202.987 246.406 207.815 242.374 211.383 238.317C212.22 237.362 212.525 236.044 212.189 234.822L211.753 233.242L195.402 248.535L195.413 248.535Z",
    fill: "#00FF9F",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.441 232.894L177.34 240.222C177.301 243.075 178.291 245.835 180.135 248.013C183.549 252.043 189.415 258.648 194.376 262.596C195.68 263.634 197.583 262.531 197.327 260.879L195.402 248.524L177.441 232.894Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M195.332 248.449L197.257 260.804C197.513 262.457 195.61 263.56 194.306 262.522C193.289 261.71 192.232 260.786 191.171 259.801C192.246 259.859 193.277 258.927 193.08 257.682L191.155 245.327L195.332 248.449Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.393 241.726C200.552 245.319 195.546 248.539 195.546 248.539C195.546 248.539 164.227 222.972 159.952 214.631C155.682 206.285 158.493 192.65 158.493 192.65C158.493 192.65 172.296 190.757 180.333 195.58C188.369 200.402 211.896 232.957 211.896 232.957C211.896 232.957 208.24 238.139 204.404 241.727L204.393 241.726Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 193.665C160.202 199.006 162.066 204.227 165.029 208.797C168.094 213.293 172.131 216.955 175.849 220.884C183.48 228.514 191.244 236.011 199.238 243.259C191.67 235.569 183.952 228.041 176.377 220.357C172.652 216.511 168.626 212.828 165.506 208.48C162.482 204.053 160.493 198.926 159.442 193.676L159.442 193.665Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.726 216.46C185.329 220.884 180.36 224.661 175.578 228.661C180.853 225.372 185.971 221.466 189.726 216.46Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.13 217.977C175.13 217.977 176.067 220.024 184.306 217.112C192.545 214.199 192.853 220.285 192.853 220.285C192.853 220.285 186.603 217.683 185.253 218.859C185.253 218.859 189.792 221.288 192.225 224.108C194.658 226.927 205.265 240.911 205.265 240.911L211.971 233.027C211.971 233.027 208.796 231.321 206.089 227.876C198.28 217.94 182.976 197.912 179.785 196.672C175.492 195.012 165.004 191.601 159.609 192.821C159.609 192.821 174.769 199.687 177.731 203.635C180.692 207.582 175.13 217.977 175.13 217.977Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.744 193.081C161.744 193.081 171.388 194.176 177.797 199.672C184.205 205.168 193.009 215.937 193.009 215.937C193.009 215.937 180.06 201.563 177.135 200.011C174.21 198.458 166.915 194.22 161.744 193.081Z",
    fill: "#A6A5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.906 236.575C178.268 240.73 178.834 245.887 182.375 248.627C179.548 245.294 179.178 240.761 178.906 236.575Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.159 251.32C195.814 251.148 195.611 248.747 195.019 248.183L189.014 243.073L177.447 232.889C177.447 232.889 188.182 243.711 191.414 248.535C192.202 249.711 193.338 250.615 194.665 251.126L195.164 251.315L195.159 251.32Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.917 194.747C158.917 194.747 158.051 208.186 162.757 214.953C167.462 221.719 182.688 236.263 182.688 236.263C182.688 236.263 170.095 227.039 163.42 217.708C156.745 208.376 158.588 203.428 158.911 194.752L158.917 194.747Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M181.391 217.742C178.333 220.603 173.534 220.442 170.673 217.383C167.812 214.325 167.973 209.526 171.031 206.665C174.09 203.804 178.889 203.965 181.75 207.024C184.61 210.082 184.45 214.881 181.391 217.742Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.863 228.357C201.303 228.881 200.424 228.851 199.9 228.291C199.375 227.73 199.405 226.851 199.965 226.327C200.526 225.803 201.405 225.832 201.929 226.393C202.453 226.953 202.424 227.832 201.863 228.357Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.531 224.852C199.253 225.113 198.816 225.098 198.555 224.819C198.294 224.541 198.309 224.104 198.588 223.843C198.866 223.582 199.303 223.597 199.564 223.876C199.825 224.154 199.81 224.591 199.531 224.852Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.369 223.209C201.17 223.395 200.857 223.385 200.67 223.185C200.484 222.986 200.494 222.673 200.693 222.486C200.893 222.3 201.206 222.31 201.393 222.51C201.579 222.709 201.569 223.022 201.369 223.209Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.942 216.279C194.758 216.451 194.47 216.441 194.298 216.257C194.126 216.074 194.136 215.786 194.32 215.614C194.503 215.442 194.791 215.452 194.963 215.635C195.135 215.819 195.125 216.107 194.942 216.279Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.346 213.826C193.118 214.04 192.761 214.028 192.548 213.8C192.334 213.572 192.346 213.214 192.574 213.001C192.802 212.788 193.16 212.8 193.373 213.028C193.586 213.256 193.574 213.613 193.346 213.826Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.003 228.52C180.604 228.893 179.978 228.873 179.605 228.474C179.232 228.075 179.253 227.449 179.652 227.076C180.051 226.702 180.677 226.723 181.05 227.122C181.423 227.521 181.402 228.147 181.003 228.52Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.719 230.355C182.52 230.541 182.207 230.531 182.02 230.331C181.833 230.132 181.844 229.819 182.043 229.632C182.243 229.446 182.556 229.456 182.742 229.656C182.929 229.855 182.918 230.168 182.719 230.355Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M189.726 216.46C189.726 216.46 188.383 220.586 188.506 222.545C188.63 224.504 188.643 224.255 186.91 227.113C185.176 229.971 184.117 231.229 181.321 230.308C178.525 229.387 175.578 228.661 175.578 228.661L183.258 222.875L189.726 216.46Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.507 253.414C189.073 253.82 188.392 253.797 187.987 253.363C187.581 252.929 187.604 252.249 188.038 251.843C188.471 251.437 189.152 251.46 189.558 251.894C189.963 252.328 189.941 253.008 189.507 253.414Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.383 252.165C187.231 252.307 186.992 252.299 186.85 252.147C186.708 251.995 186.716 251.757 186.868 251.615C187.02 251.473 187.258 251.481 187.4 251.633C187.542 251.785 187.535 252.023 187.383 252.165Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.582 214.057L204.9 214.446C207.75 214.597 210.437 215.769 212.487 217.754C216.28 221.43 222.478 227.724 226.086 232.938C227.035 234.308 225.807 236.133 224.176 235.767L211.977 233.021L197.582 214.057Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.157 215.765C205.315 216.315 209.819 216.982 212.95 220.03C210.453 216.314 205.346 215.405 201.157 215.765Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.54 226.937C215.106 227.343 214.426 227.32 214.02 226.886C213.614 226.452 213.637 225.772 214.071 225.366C214.505 224.96 215.185 224.983 215.591 225.417C215.997 225.851 215.974 226.531 215.54 226.937Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.431 224.739C214.279 224.882 214.04 224.874 213.898 224.722C213.756 224.57 213.764 224.331 213.916 224.189C214.068 224.047 214.306 224.055 214.449 224.207C214.591 224.359 214.583 224.597 214.431 224.739Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M211.993 232.867L224.192 235.613C225.824 235.978 227.051 234.153 226.103 232.783C225.361 231.714 224.51 230.597 223.598 229.472C223.584 230.549 222.585 231.516 221.356 231.236L209.157 228.49L211.993 232.867Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M168.592 203.54C172.155 199.983 175.213 196.208 176.659 194.007C177.11 194.123 177.556 194.243 177.995 194.391C176.948 196.167 174.456 199.743 171.198 203.178C170.709 203.689 170.214 204.206 169.703 204.716C166.336 208.069 162.365 211.063 159.023 212.501C158.91 212.07 158.813 211.633 158.728 211.197C161.906 209.654 165.455 206.679 168.603 203.541L168.592 203.54Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.171 199.366C167.864 199.654 167.382 199.637 167.095 199.33C166.807 199.023 166.823 198.541 167.131 198.254C167.438 197.967 167.92 197.983 168.207 198.29C168.494 198.597 168.478 199.079 168.171 199.366Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.946 199.125C167.771 199.288 167.498 199.279 167.335 199.105C167.172 198.931 167.182 198.658 167.356 198.495C167.53 198.332 167.803 198.341 167.966 198.515C168.129 198.689 168.12 198.962 167.946 199.125Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.813 196.078C170.506 196.365 170.024 196.349 169.737 196.042C169.45 195.735 169.466 195.253 169.773 194.965C170.08 194.678 170.562 194.694 170.849 195.001C171.137 195.309 171.121 195.79 170.813 196.078Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.588 195.837C170.414 196 170.141 195.99 169.978 195.816C169.815 195.642 169.824 195.369 169.998 195.206C170.172 195.043 170.446 195.052 170.609 195.226C170.771 195.401 170.762 195.674 170.588 195.837Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.069 202.44C164.762 202.727 164.28 202.711 163.993 202.404C163.705 202.096 163.722 201.615 164.029 201.327C164.336 201.04 164.818 201.056 165.105 201.363C165.392 201.67 165.376 202.152 165.069 202.44Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.844 202.199C164.67 202.361 164.396 202.352 164.233 202.178C164.071 202.004 164.08 201.731 164.254 201.568C164.428 201.405 164.701 201.414 164.864 201.588C165.027 201.762 165.018 202.036 164.844 202.199Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.58 205.305C161.273 205.592 160.791 205.576 160.503 205.269C160.216 204.962 160.232 204.48 160.539 204.193C160.847 203.906 161.328 203.922 161.616 204.229C161.903 204.536 161.887 205.018 161.58 205.305Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.354 205.064C161.18 205.227 160.907 205.218 160.744 205.044C160.581 204.87 160.59 204.596 160.765 204.434C160.939 204.271 161.212 204.28 161.375 204.454C161.538 204.628 161.529 204.901 161.354 205.064Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.019 248.183C195.019 248.183 204.623 242.167 208.332 236.376",
    stroke: "#3F3D56",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M206.917 242.999L200.951 248.159C200.82 248.26 200.7 248.362 200.581 248.452C199.673 249.183 198.487 249.443 197.363 249.183C198.379 247.201 200.116 244.738 202.897 243.287C204.423 242.494 207.055 241.676 209.518 240.459C208.666 241.33 207.794 242.179 206.917 242.988L206.917 242.999Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.959 251.793C213.959 251.793 205.63 247.255 195.608 236.539C186.396 226.69 186.89 223.529 187.028 223.079C187.04 223.046 187.063 223.013 187.086 222.992C187.086 222.992 187.143 222.949 187.177 222.939C187.63 222.827 190.822 222.55 200.034 232.4C210.056 243.115 214.028 251.729 214.028 251.729L213.954 251.798L213.959 251.793Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.443 238.445C201.797 238.146 203.204 238.754 204.286 239.29C204.668 239.481 205.04 238.993 204.745 238.678C203.984 237.864 202.622 237.063 200.394 237.588C198.2 238.103 198.977 236.624 198.653 236.336L198.551 236.227C198.551 236.227 198.17 235.831 197.488 235.642C196.932 235.484 196.596 234.906 196.737 234.345C197.033 233.144 197.256 231.096 195.966 229.487C194.548 227.729 189.591 224.486 186.985 222.85C186.985 222.85 187.042 222.807 187.076 222.797C187.53 222.685 190.721 222.408 199.934 232.258C209.956 242.973 213.927 251.587 213.927 251.587L213.853 251.656C213.853 251.656 213.727 251.591 213.488 251.45C212.01 249.64 206.962 243.484 205.634 241.984C204.072 240.221 201.442 238.456 201.442 238.456L201.443 238.445Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.303 233.558C194.802 234.026 194.017 234 193.549 233.499C193.082 232.999 193.108 232.214 193.608 231.746C194.108 231.278 194.893 231.304 195.361 231.805C195.829 232.305 195.803 233.09 195.303 233.558Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M187.207 223.19C187.207 223.19 187.243 223.125 187.266 223.103C187.289 223.082 187.323 223.061 187.356 223.051C187.614 222.993 188.751 222.875 191.36 224.573C191.326 224.583 191.298 224.599 191.275 224.62C191.246 224.647 191.229 224.674 191.216 224.707C191.074 225.152 190.585 228.318 199.797 238.168C205.17 243.913 210.052 247.88 213.436 250.326C213.965 251.293 214.208 251.829 214.208 251.829L214.134 251.899C214.134 251.899 205.804 247.361 195.782 236.645C186.57 226.796 187.065 223.635 187.202 223.184L187.207 223.19Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.218 230.434C195.028 230.612 194.73 230.602 194.552 230.412C194.375 230.222 194.385 229.924 194.575 229.746C194.765 229.568 195.063 229.578 195.24 229.768C195.418 229.958 195.408 230.256 195.218 230.434Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.451 230.786C193.29 230.937 193.036 230.928 192.885 230.767C192.734 230.605 192.743 230.352 192.904 230.201C193.066 230.05 193.319 230.058 193.47 230.22C193.621 230.381 193.613 230.634 193.451 230.786Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.725 226.585C199.144 230.115 202.73 234.501 206.163 238.964C203.19 234.188 199.481 229.671 194.725 226.585Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M183.349 238.096C183.349 238.096 181.402 234.037 184.064 234.976C186.726 235.915 185.537 236.447 189.624 238.461C193.711 240.475 192.112 241.604 194.096 243.242C196.079 244.881 196.4 242.592 197.897 242.331C199.394 242.07 201.108 241.811 201.849 243.074C202.59 244.337 194.417 247.757 194.417 247.757L183.354 238.09L183.349 238.096Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.563 242.548C196.313 242.782 195.92 242.769 195.686 242.518C195.452 242.268 195.465 241.876 195.715 241.642C195.966 241.408 196.358 241.421 196.592 241.671C196.826 241.921 196.813 242.314 196.563 242.548Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.038 238.653C192.956 238.73 192.827 238.726 192.75 238.643C192.673 238.561 192.677 238.432 192.76 238.355C192.842 238.278 192.971 238.282 193.048 238.364C193.125 238.447 193.121 238.576 193.038 238.653Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.838 222.161L179.905 221.646L179.66 221.188C179.545 220.973 179.72 220.713 179.963 220.743L180.478 220.81L180.936 220.565C181.151 220.45 181.411 220.625 181.381 220.868L181.314 221.383L181.56 221.841C181.675 222.056 181.499 222.316 181.256 222.286L180.742 222.219L180.284 222.464C180.069 222.579 179.808 222.404 179.838 222.161Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.189 221.434C182.965 221.644 182.612 221.633 182.402 221.408C182.191 221.183 182.203 220.83 182.428 220.62C182.653 220.41 183.006 220.422 183.216 220.646C183.426 220.871 183.414 221.224 183.189 221.434Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.917 260.44C222.465 260.864 221.754 260.84 221.331 260.387C220.907 259.934 220.931 259.224 221.384 258.8C221.837 258.377 222.547 258.401 222.971 258.854C223.394 259.306 223.37 260.017 222.917 260.44Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.466 258.326C221.311 258.471 221.068 258.463 220.923 258.307C220.778 258.152 220.786 257.909 220.941 257.764C221.096 257.619 221.34 257.627 221.485 257.782C221.63 257.937 221.622 258.18 221.466 258.326Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.62 251.432C217.209 251.817 216.563 251.796 216.178 251.384C215.793 250.972 215.814 250.327 216.226 249.942C216.638 249.557 217.284 249.578 217.669 249.99C218.054 250.402 218.032 251.047 217.62 251.432Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.261 251.371C219.128 251.495 218.919 251.488 218.795 251.355C218.67 251.222 218.677 251.014 218.81 250.889C218.943 250.765 219.152 250.772 219.276 250.905C219.401 251.038 219.394 251.246 219.261 251.371Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.603 253.997C211.483 254.11 211.294 254.104 211.181 253.983C211.069 253.863 211.075 253.674 211.195 253.562C211.316 253.449 211.505 253.455 211.617 253.576C211.73 253.696 211.723 253.885 211.603 253.997Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28 254.847C212.204 254.918 212.085 254.914 212.014 254.838C211.943 254.762 211.947 254.643 212.023 254.572C212.099 254.501 212.218 254.505 212.289 254.581C212.36 254.657 212.356 254.776 212.28 254.847Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.835 216.285C177.776 219.146 172.977 218.985 170.116 215.926C167.256 212.868 167.416 208.069 170.475 205.208C173.533 202.347 178.332 202.508 181.193 205.567C184.054 208.625 183.893 213.424 180.835 216.285Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.577 216.021C177.651 218.757 173.061 218.604 170.325 215.678C167.588 212.752 167.742 208.162 170.667 205.426C173.593 202.689 178.183 202.843 180.92 205.769C183.656 208.694 183.503 213.284 180.577 216.021Z",
    stroke: "#04DAF6",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.698 206.493C171.492 206.685 171.169 206.674 170.977 206.469C170.784 206.263 170.795 205.94 171.001 205.747C171.207 205.555 171.53 205.566 171.722 205.772C171.915 205.977 171.904 206.3 171.698 206.493Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.331 215.723C180.125 215.916 179.803 215.905 179.61 215.699C179.418 215.493 179.428 215.17 179.634 214.978C179.84 214.785 180.163 214.796 180.355 215.002C180.548 215.208 180.537 215.531 180.331 215.723Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.399 215.425C171.194 215.617 170.871 215.607 170.678 215.401C170.486 215.195 170.496 214.872 170.702 214.68C170.908 214.487 171.231 214.498 171.423 214.704C171.616 214.91 171.605 215.232 171.399 215.425Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.63 206.792C180.424 206.984 180.101 206.973 179.909 206.767C179.716 206.562 179.727 206.239 179.933 206.046C180.139 205.854 180.461 205.865 180.654 206.07C180.846 206.276 180.836 206.599 180.63 206.792Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.701 210.897C169.496 211.09 169.173 211.079 168.98 210.873C168.788 210.667 168.798 210.344 169.004 210.152C169.21 209.959 169.533 209.97 169.725 210.176C169.918 210.382 169.907 210.705 169.701 210.897Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.328 211.319C182.122 211.512 181.799 211.501 181.607 211.295C181.414 211.09 181.425 210.767 181.631 210.574C181.837 210.382 182.16 210.392 182.352 210.598C182.545 210.804 182.534 211.127 182.328 211.319Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.804 217.421C175.598 217.614 175.275 217.603 175.082 217.397C174.89 217.192 174.901 216.869 175.107 216.676C175.312 216.484 175.635 216.494 175.828 216.7C176.02 216.906 176.009 217.229 175.804 217.421Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.226 204.795C176.02 204.988 175.697 204.977 175.505 204.771C175.312 204.565 175.323 204.242 175.529 204.05C175.735 203.857 176.057 203.868 176.25 204.074C176.442 204.28 176.432 204.603 176.226 204.795Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.135 214.467C177.08 216.389 173.856 216.281 171.934 214.226C170.012 212.171 170.12 208.947 172.175 207.025C174.23 205.103 177.454 205.211 179.376 207.266C181.298 209.321 181.19 212.545 179.135 214.467Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.506 207.931L180.554 209.388C180.794 210.185 180.833 211.031 180.678 211.842L170.618 210.223C170.723 209.415 171.016 208.625 171.506 207.931Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.581 210.677L180.568 212.288C180.518 212.464 180.457 212.64 180.384 212.804L170.59 211.227C170.58 211.043 170.574 210.865 170.581 210.677Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M173.874 214.347C178.135 213.812 179.816 214.207 181.049 211.538C181.827 209.853 181.997 207.92 182.021 206.727C183.825 209.736 183.359 213.698 180.688 216.196C177.706 218.985 173.071 218.913 170.178 216.084C170.802 215.349 171.916 214.598 173.879 214.352L173.874 214.347Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.755 211.226C158.448 210.116 158.214 208.969 158.053 207.809C160.788 206.895 162.978 204.997 166.783 201.514C170.398 198.208 173.061 194.287 173.541 193.076C174.66 193.307 175.767 193.594 176.838 193.958C175.711 195.925 172.866 200.306 169.03 203.905C164.919 207.75 161.982 209.895 158.766 211.226L158.755 211.226Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M167.936 202.746C171.326 199.35 174.224 195.725 175.572 193.615C176.012 193.741 176.452 193.867 176.886 194.02C175.907 195.732 173.565 199.169 170.461 202.459C169.995 202.948 169.523 203.444 169.035 203.933C165.828 207.136 162.029 209.969 158.808 211.294C158.689 210.868 158.581 210.442 158.49 210.011C161.554 208.575 164.942 205.751 167.941 202.752L167.936 202.746Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_10035",
    x1: 36.3228,
    y1: 126.873,
    x2: 211.404,
    y2: 126.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_10035",
    x1: 36.3129,
    y1: 81.1447,
    x2: 154.373,
    y2: 81.1447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_10035",
    x1: 37.0605,
    y1: 114.407,
    x2: 211.384,
    y2: 114.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_10035",
    x1: 59.2454,
    y1: 180.185,
    x2: 207.899,
    y2: 180.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1023_10035",
    x1: 36.3033,
    y1: 92.2125,
    x2: 175.743,
    y2: 92.2125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1023_10035",
    x1: 43.2646,
    y1: 160.797,
    x2: 211.404,
    y2: 160.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1023_10035",
    x1: 36.3131,
    y1: 124.004,
    x2: 211.685,
    y2: 124.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AF0020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B0041E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5121A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BE2913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1023_10035",
    x1: 51.7792,
    y1: 226.623,
    x2: 219.035,
    y2: 89.4358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#670020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6B031E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#790D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#901E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B1360F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1023_10035",
    x1: 16.2251,
    y1: 194.04,
    x2: 191.85,
    y2: 49.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#670020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6B031E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#790D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#901E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B1360F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1023_10035",
    x1: 112.839,
    y1: 232.254,
    x2: 224.142,
    y2: 140.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#670020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6B031E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#790D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#901E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B1360F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1023_10035",
    x1: 6.38034,
    y1: 143.068,
    x2: 154.189,
    y2: 21.8327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#670020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6B031E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#790D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#901E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B1360F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA490A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_10035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1612,
    height: 103.573,
    fill: "white",
    transform: "matrix(-0.730341 0.683082 0.683082 0.730341 174.961 177)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarte);
export default __webpack_public_path__ + "static/media/marte.ecdbc73ad367fd76d4b37dd547c452b7.svg";
export { ForwardRef as ReactComponent };